// extracted by mini-css-extract-plugin
export default {"icon":"AssignmentNoteModal_icon__Ki9Om","iconK2":"AssignmentNoteModal_iconK2__w9oQf"};